export { default as Achievements } from "./Achievements.tsx";
export { default as AdvancedPlayerSearch } from "./AdvancedPlayerSearch.tsx";
export { default as AllStar } from "./AllStar.tsx";
export { default as AllStarDunk } from "./AllStarDunk.tsx";
export { default as AllStarHistory } from "./AllStarHistory.tsx";
export { default as AllStarTeams } from "./AllStarTeams/index.tsx";
export { default as AllStarThree } from "./AllStarThree.tsx";
export { default as AutoExpand } from "./AutoExpand.tsx";
export { default as AutoRelocate } from "./AutoRelocate.tsx";
export { default as AwardRaces } from "./AwardRaces.tsx";
export { default as AwardsRecords } from "./AwardsRecords.tsx";
export { default as Colleges } from "./Colleges.tsx";
export { default as ComparePlayers } from "./ComparePlayers/index.tsx";
export { default as Countries } from "./Countries.tsx";
export { default as CustomizePlayer } from "./CustomizePlayer/index.tsx";
export { default as DailySchedule } from "./DailySchedule.tsx";
export { default as DangerZone } from "./DangerZone/index.tsx";
export { default as Dashboard } from "./GmStart.tsx";
export { default as DefaultNewLeagueSettings } from "./DefaultNewLeagueSettings/index.tsx";
export { default as DeleteOldData } from "./DeleteOldData.tsx";
export { default as Depth } from "./Depth.tsx";
export { default as Draft } from "./GmDraft.tsx";
export { default as DraftLottery } from "./GmLottery.tsx";
export { default as DraftPicks } from "./DraftPicks.tsx";
export { default as DraftScouting } from "./DraftScouting/index.tsx";
export { default as DraftTeamHistory } from "./DraftTeamHistory.tsx";
export { default as Dropbox } from "./Dropbox.tsx";
export { default as EightyTwoZeroDraft } from "./EightyTwoZeroDraft.tsx";
export { default as EditAwards } from "./EditAwards.tsx";
export { default as Exhibition } from "./Exhibition.tsx";
export { default as ExhibitionGame } from "./ExhibitionGame.tsx";
export { default as ExpansionDraft } from "./ExpansionDraft.tsx";
export { default as ExportLeague } from "./ExportLeague.tsx";
export { default as ExportPlayers } from "./ExportPlayers.tsx";
export { default as ExportStats } from "./ExportStats.tsx";
export { default as FantasyDraft } from "./FantasyDraft.tsx";
// Mobile GM frontend: the Free Agents route now renders the new mobile screen.
// (Original desktop screen preserved in ./FreeAgents.tsx for rollback.)
export { default as FreeAgents } from "./GmFreeAgency.tsx";
export { default as Signings } from "./GmRosterSignings.tsx";
export { default as Frivolities } from "./Frivolities.tsx";
export { default as FrivolitiesDraftClasses } from "./FrivolitiesDraftClasses.tsx";
export { default as FrivolitiesDraftPosition } from "./FrivolitiesDraftPosition.tsx";
export { default as FrivolitiesJerseyNumbers } from "./FrivolitiesJerseyNumbers.tsx";
export { default as FrivolitiesTeamSeasons } from "./FrivolitiesTeamSeasons.tsx";
export { default as FrivolitiesTrades } from "./FrivolitiesTrades.tsx";
export { default as GlobalSettings } from "./GlobalSettings/index.tsx";
export { default as GmHistory } from "./GmHistory.tsx";
export { default as GameLog } from "./GameLog.tsx";
export { default as GodMode } from "./GodMode.tsx";
export { default as HallOfFame } from "./HallOfFame.tsx";
export { default as HeadToHead } from "./HeadToHead.tsx";
export { default as HeadToHeadAll } from "./HeadToHeadAll.tsx";
// Mobile "Year in Review" season recap replaces the desktop Basketball-Reference-style summary.
export { default as History } from "./GmSeasonRecap.tsx";
export { default as HistoryAll } from "./HistoryAll.tsx";
export { default as ImportPlayers } from "./ImportPlayers.tsx";
export { default as ImportPlayersReal } from "./ImportPlayersReal.tsx";
export { default as Inbox } from "./Inbox.tsx";
export { default as Injuries } from "./Injuries.tsx";
export { default as KeyboardShortcuts } from "./KeyboardShortcuts.tsx";
export { default as Leaders } from "./Leaders.tsx";
export { default as LeadersProgressive } from "./LeadersProgressive.tsx";
export { default as LeadersYears } from "./LeadersYears.tsx";
export { default as LeagueDashboard } from "./GmHome.tsx";
export { default as LeagueFinances } from "./LeagueFinances.tsx";
export { default as LeagueStats } from "./LeagueStats.tsx";
export { default as LiveGame } from "./LiveGame/index.tsx";
export { default as ManageConfs } from "./ManageConfs.tsx";
export { default as ManageTeams } from "./ManageTeams/index.tsx";
// Mobile GM frontend: the owner's annual performance evaluation now renders in the branded mobile
// message screen (fired → single "Start New League" action). Original desktop view preserved in
// ./Message/ for rollback.
export { default as Message } from "./GmMessage.tsx";
export { default as Most } from "./Most/index.tsx";
export { default as MultiTeamMode } from "./MultiTeamMode.tsx";
export { default as NegotiationList } from "./GmNegotiationList.tsx";
export { default as NewLeague } from "./NewLeague/index.tsx";
export { default as NewTeam } from "./NewTeam.tsx";
export { default as News } from "./News.tsx";
export { default as Notes } from "./Notes.tsx";
// Mobile GM frontend: the player route now renders the full-screen mobile player
// profile (compact card → profile). Original desktop page preserved in ./Player/ for rollback.
export { default as Player } from "./GmPlayer.tsx";
export { default as PlayerBios } from "./PlayerBios.tsx";
export { default as PlayerFeats } from "./PlayerFeats.tsx";
export { default as PlayerGameLog } from "./PlayerGameLog.tsx";
export { default as PlayerRatingDists } from "./PlayerRatingDists.tsx";
export { default as PlayerRatings } from "./PlayerRatings.tsx";
export { default as PlayerStatDists } from "./PlayerStatDists.tsx";
export { default as PlayerGraphs } from "./PlayerGraphs/index.tsx";
export { default as PlayerStats } from "./GmStats.tsx";
export { default as Playoffs } from "./GmPlayoffs.tsx";
export { default as PowerRankings } from "./PowerRankings.tsx";
export { default as ProtectPlayers } from "./ProtectPlayers.tsx";
export { default as Relatives } from "./Relatives.tsx";
export { default as ChallengeLeaderboard } from "./ChallengeLeaderboard.tsx";
export { default as ChallengeResult } from "./ChallengeResult.tsx";
export { default as ProgressReport } from "./ProgressReport.tsx";
export { default as ReportCard } from "./ReportCard.tsx";
export { default as ReportCardLeaderboard } from "./ReportCardLeaderboard.tsx";
export { default as Roster } from "./GmRoster.tsx";
export { default as RosterContinuity } from "./RosterContinuity.tsx";
export { default as SavedTrades } from "./SavedTrades.tsx";
export { default as Schedule } from "./Schedule.tsx";
export { default as ScheduleEditor } from "./ScheduleEditor/index.tsx";
export { default as ScheduledEvents } from "./ScheduledEvents.tsx";
export { default as SeasonPreview } from "./GmSeasonPreview.tsx";
export { default as Settings } from "./Settings/index.tsx";
export { default as Snacks } from "./Snacks.tsx";
export { default as Standings } from "./Standings.tsx";
export { default as TeamFinances } from "./TeamFinances/index.tsx";
export { default as TeamGraphs } from "./TeamGraphs/index.tsx";
export { default as TeamHistory } from "./TeamHistory/index.tsx";
export { default as TeamRecords } from "./TeamRecords.tsx";
export { default as TeamStatDists } from "./TeamStatDists.tsx";
export { default as TeamStats } from "./TeamStats.tsx";
export { default as TeamStatsMobile } from "./GmTeamStats.tsx";
export { default as TragicDeaths } from "./TragicDeaths.tsx";
export { default as Trade } from "./GmTrade.tsx";
export { default as TradeProposals } from "./TradeProposals.tsx";
export { default as TradeSummary } from "./TradeSummary/index.tsx";
export { default as TradingBlock } from "./TradingBlock/index.tsx";
export { default as Transactions } from "./Transactions.tsx";
export { default as UpcomingFreeAgents } from "./UpcomingFreeAgents.tsx";
export { default as Upgrade65 } from "./Upgrade65.tsx";
export { default as WatchList } from "./WatchList.tsx";
